module.exports = __webpack_public_path__ + "img/Slice 15@2x.a062f060.png";